<template>
  <FullScreenDialog
    v-model="enablingTypeDialog"
    title="Tipo di Abilitazione"
    :routeFather="pathToGoBack"
  >
    <template v-slot:toolbar-extension>
      <v-tabs v-model="tab" align-with-title>
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          v-for="tab in enablingTypeTabs"
          :key="tab.key"
          @click="$router.push({ name: tab.routeName }).catch(() => {})"
          >{{ tab.title }}</v-tab
        >
      </v-tabs>
    </template>
    <template v-slot:content>
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="tabItem in enablingTypeTabs" :key="tabItem.key">
          <v-card flat>
            <router-view></router-view>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </template>
    <template v-slot:footer-actions>
      <v-spacer></v-spacer>
      <v-btn
        text
        color="error"
        @click="$router.push({path: pathToGoBack})"
      >Annulla</v-btn>
      <v-btn
        text
        color="default"
        :disabled="!formValid"
        @click="submitForm"
        :loading="loading"
      >Salva</v-btn>
    </template>
  </FullScreenDialog>
</template>

<script>
import FullScreenDialog from "@/components/common/FullScreenDialog.vue";
import enablingTypesService from '@/services/enablingTypes/enablingTypes.service.js'
import enablingTypeForm from '@/services/enablingTypes/enablingType.form.js'

export default {
  name: "EnablingTypesRegistryNewForm",
  components: {
    FullScreenDialog
  },
  data: function() {
    return {
      tab: null,
      enablingTypeDialog: this.openDialog,
      enablingTypeTabs: this.tabs,
      formValid: false,
      enablingType: undefined,
      loading: false
    };
  },
  mounted() {
    this.changeTabBasedOnRoute(this.$route.name)

    let self = this
    enablingTypeForm.resetEnablingType()
    enablingTypeForm.on('update', function(data) {
      self.enablingType = data.enablingType
    })

    enablingTypeForm.on('valid-change', function(data) {
      self.formValid = data
    })
  },
  props: {
    openDialog: {
      type: Boolean,
      default: false
    },
    pathToGoBack: {
      type: String,
      default: "/registries"
    },
    tabs: {
      type: Array,
      default: function() {
        return [
          {
            key: 0,
            title: "Generale",
            routeName: "EnablingTypesGeneralNewFormTab",
          }
        ];
      }
    }
  },
  methods: {
    changeTabBasedOnRoute(routeName) {
      for(let i = 0; i < this.tabs.length; i++) {
        if(this.tabs[i].routeName == routeName) {
          this.tab = i
          break
        }
      }
    },
    submitForm() {
      this.loading = true
      enablingTypesService.create(this.enablingType).then((result) => {
        this.loading = false
        this.$router.push({path: this.pathToGoBack})
      })
    }
  },
  watch: {
    openDialog(newVal) {
      this.enablingTypeDialog = newVal;
    }
  },
  computed: {
  }
};
</script>